import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngxs/store';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { OpenMessagePopup } from '../../dashboard/store/dashboard.actions';

@Injectable()
export class ErrorMessageInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((event: HttpErrorResponse) => {
        if ((event.error || {}).notifyUser) {
          const closeWithoutRedirect: boolean = request.url.includes('notify');
          return this.store
            .dispatch(new OpenMessagePopup(event.error.message, event.error, closeWithoutRedirect))
            .pipe(switchMap(() => throwError(() => event)));
        }
        return throwError(() => event);
      }),
    );
  }
}
